import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const StaffGradeService = {
  getStaffGrades(obj) {
    return httpClient.post(endPoints.getStaffGrades, obj);
  },
  deleteStaffGrade(obj) {
    return httpClient.post(endPoints.deleteStaffGrade, obj);
  },
  updateStaffGrade(obj) {
    return httpClient.post(endPoints.updateStaffGrade, obj);
  },
  addStaffGrade(obj) {
    return httpClient.post(endPoints.addStaffGrade, obj);
  }
};

export default StaffGradeService;



// WEBPACK FOOTER //
// ./src/service/StaffGradeService.js